import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as d, normalizeClass as l, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconChevronDown",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(a, t, i, _, f, e) {
  return n(), d("svg", {
    "aria-label": i.ariaLabel,
    class: l([e.iconSizeClass, "d-icon d-icon--chevron-down"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Chevron Down",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.646 4.146a.5.5 0 0 1 .708 0L6 6.793l2.646-2.647a.5.5 0 1 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const w = /* @__PURE__ */ s(c, [["render", u]]);
export {
  w as default
};
//# sourceMappingURL=chevron-down.js.map
